import { Project } from '@constants/router.const';

const PROJECT: string = Project.CALLBACK;
const CALLBACK: string = `dice.${PROJECT}`;
const CALLBACK_TEMPLATE_SEARCH: string = `${CALLBACK}.search`;

export const CALLBACK_STATE = {
  PROJECT,
  CALLBACK,
  CALLBACK_TEMPLATE_SEARCH: CALLBACK_TEMPLATE_SEARCH,
};
